// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReconcileImpactedCommitmentsStepQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
}>;


export type ReconcileImpactedCommitmentsStepQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, impactedCommitments: Array<
      | { __typename?: 'Commitment', shortName: string, committedInCents: number, id: string, pendingBilledInCents?: number | null | undefined, status: Types.CommitmentStatus, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'CommitmentChangeOrder', shortName: string, committedInCents: number, id: string, pendingBilledInCents?: number | null | undefined, status: Types.CommitmentStatus, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } }
    > } };

export type ReconcileImpactedCommitmentsStep_CommitmentLike_Commitment_Fragment = { __typename?: 'Commitment', shortName: string, committedInCents: number, id: string, pendingBilledInCents?: number | null | undefined, status: Types.CommitmentStatus, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } };

export type ReconcileImpactedCommitmentsStep_CommitmentLike_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', shortName: string, committedInCents: number, id: string, pendingBilledInCents?: number | null | undefined, status: Types.CommitmentStatus, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } };

export type ReconcileImpactedCommitmentsStep_CommitmentLikeFragment =
  | ReconcileImpactedCommitmentsStep_CommitmentLike_Commitment_Fragment
  | ReconcileImpactedCommitmentsStep_CommitmentLike_CommitmentChangeOrder_Fragment
;

export type ReconcileImpactedCommitments_CommitmentLike_Commitment_Fragment = { __typename?: 'Commitment', id: string, pendingBilledInCents?: number | null | undefined, status: Types.CommitmentStatus };

export type ReconcileImpactedCommitments_CommitmentLike_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', id: string, pendingBilledInCents?: number | null | undefined, status: Types.CommitmentStatus };

export type ReconcileImpactedCommitments_CommitmentLikeFragment =
  | ReconcileImpactedCommitments_CommitmentLike_Commitment_Fragment
  | ReconcileImpactedCommitments_CommitmentLike_CommitmentChangeOrder_Fragment
;

export const ReconcileImpactedCommitments_CommitmentLikeFragmentDoc = gql`
    fragment ReconcileImpactedCommitments_CommitmentLike on CommitmentLike {
  id
  status
  ... on Commitment {
    id
    pendingBilledInCents
  }
  ... on CommitmentChangeOrder {
    id
    pendingBilledInCents
  }
}
    `;
export const ReconcileImpactedCommitmentsStep_CommitmentLikeFragmentDoc = gql`
    fragment ReconcileImpactedCommitmentsStep_CommitmentLike on CommitmentLike {
  ...ReconcileImpactedCommitments_CommitmentLike
  shortName
  committedInCents
  tradePartner {
    id
    name
  }
  blueprintUrl {
    path
  }
}
    ${ReconcileImpactedCommitments_CommitmentLikeFragmentDoc}`;
export const ReconcileImpactedCommitmentsStepDocument = gql`
    query ReconcileImpactedCommitmentsStep($changeEventId: ID!) {
  changeEvent(id: $changeEventId) {
    id
    impactedCommitments {
      ...ReconcileImpactedCommitmentsStep_CommitmentLike
    }
  }
}
    ${ReconcileImpactedCommitmentsStep_CommitmentLikeFragmentDoc}`;

/**
 * __useReconcileImpactedCommitmentsStepQuery__
 *
 * To run a query within a React component, call `useReconcileImpactedCommitmentsStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useReconcileImpactedCommitmentsStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReconcileImpactedCommitmentsStepQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *   },
 * });
 */
export function useReconcileImpactedCommitmentsStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReconcileImpactedCommitmentsStepQuery, ReconcileImpactedCommitmentsStepQueryVariables> & ({ variables: ReconcileImpactedCommitmentsStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReconcileImpactedCommitmentsStepQuery, ReconcileImpactedCommitmentsStepQueryVariables>(ReconcileImpactedCommitmentsStepDocument, options);
      }
export function useReconcileImpactedCommitmentsStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReconcileImpactedCommitmentsStepQuery, ReconcileImpactedCommitmentsStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReconcileImpactedCommitmentsStepQuery, ReconcileImpactedCommitmentsStepQueryVariables>(ReconcileImpactedCommitmentsStepDocument, options);
        }
// @ts-ignore
export function useReconcileImpactedCommitmentsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReconcileImpactedCommitmentsStepQuery, ReconcileImpactedCommitmentsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReconcileImpactedCommitmentsStepQuery, ReconcileImpactedCommitmentsStepQueryVariables>;
export function useReconcileImpactedCommitmentsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReconcileImpactedCommitmentsStepQuery, ReconcileImpactedCommitmentsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReconcileImpactedCommitmentsStepQuery | undefined, ReconcileImpactedCommitmentsStepQueryVariables>;
export function useReconcileImpactedCommitmentsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReconcileImpactedCommitmentsStepQuery, ReconcileImpactedCommitmentsStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReconcileImpactedCommitmentsStepQuery, ReconcileImpactedCommitmentsStepQueryVariables>(ReconcileImpactedCommitmentsStepDocument, options);
        }
export type ReconcileImpactedCommitmentsStepQueryHookResult = ReturnType<typeof useReconcileImpactedCommitmentsStepQuery>;
export type ReconcileImpactedCommitmentsStepLazyQueryHookResult = ReturnType<typeof useReconcileImpactedCommitmentsStepLazyQuery>;
export type ReconcileImpactedCommitmentsStepSuspenseQueryHookResult = ReturnType<typeof useReconcileImpactedCommitmentsStepSuspenseQuery>;
export type ReconcileImpactedCommitmentsStepQueryResult = ApolloReactCommon.QueryResult<ReconcileImpactedCommitmentsStepQuery, ReconcileImpactedCommitmentsStepQueryVariables>;